/**
 * SwatchesIcon/index.js
 * desc: swatches icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const SwatchesIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="swatches icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.swatches.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 21 19" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M15.775 1.23l4.96 11.97c.42 1.01-.07 2.18-1.09 2.6l-7.36 3.05a1.998 1.998 0 01-2.6-1.08L4.725 5.8a1.999 1.999 0 011.08-2.6l7.37-3.05c.26-.11.53-.15.79-.15.77.02 1.5.48 1.81 1.23zm-13.2 16.23l-1.34-.56a2.019 2.019 0 01-1.09-2.61l2.43-5.86v9.03zM6.585 6c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0 13c-1.1 0-2-.9-2-2v-6.34L8.035 19h-1.45z" /></svg>
    </IconButton>
);


export default SwatchesIcon;
